import React from "react";
import { CheckCircle2, MessageCircle, RefreshCcw } from "lucide-react";
import NavBar from "../ProductPage_v2/components/Navbar/Navbar";

const UnsubscribeSuccess = () => {
  return (
    <>
      {/* Navbar */}
      <div className="absolute top-0 bg-[#FBF8F3] left-0 w-full">
        <div className=" max-w-[90vw] sm:max-w-6xl  mx-auto">
             <NavBar />
        </div>
      </div>

      {/* Content Section */}
      <div className="flex flex-col bg-[#FBF8F3] items-center justify-center min-h-[100dvh]  sm:min-h-screen px-4 text-center">
        {/* Icon */}
        <CheckCircle2 className="text-green-600 w-20 h-20 mb-4" />

        {/* Heading */}
        <h2 className=" text-5xl sm:text-5xl font-bomstad-semibold text-gray-800 mb-2">
          You’ve been unsubscribed
        </h2>

        {/* Description */}
        <p className="text-gray-600 max-w-xl mb-6 text-sm sm:text-lg ">
          You’ve successfully opted out of receiving WhatsApp updates from us.
          You will no longer receive further messages or notifications.
        </p>

        {/* Actions */}
        {/* <div className="flex gap-4 flex-wrap justify-center">
          <button
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-xl transition"
            onClick={() => {
              // TODO: handle re-subscribe action
            }}
          >
            <RefreshCcw className="w-4 h-4" />
            Re-subscribe
          </button>

          <button
            className="inline-flex items-center gap-2 border border-gray-300 px-4 py-2 rounded-xl text-gray-700 hover:bg-gray-100 transition"
            onClick={() => {
              // TODO: open feedback modal or redirect
            }}
          >
            <MessageCircle className="w-4 h-4" />
            Give Feedback
          </button>
        </div> */}
      </div>
    </>
  );
};

export default UnsubscribeSuccess;
